import { render } from "./MarketingPlan.vue?vue&type=template&id=9909f26a"
import script from "./MarketingPlan.vue?vue&type=script&lang=js"
export * from "./MarketingPlan.vue?vue&type=script&lang=js"

import "./MarketingPlan.vue?vue&type=style&index=0&id=9909f26a&lang=scss"
script.render = render

export default script